import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// MatchSideLite only shown for door types that have a side lite (not single/double without lites)
const SINGLE_DOUBLE_NO_LITES = [1, 5]; // door type ids without side lites

const TransomLite = ({ value = { value: '', label: '' }, onChange, disabled = false, selectedDoor, onLiteCollectionVisible }) => {
  const [selected, setSelected] = useState(value?.value || '');

  const showMatchSideLite = selectedDoor?.id && !SINGLE_DOUBLE_NO_LITES.includes(selectedDoor.id);

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const labelMap = {
      'MatchDoorLite': 'Match Door Lite',
      'MatchSideLite': 'Match Side Lite',
      'Other':         'Other',
    };
    setSelected(v);
    onChange({ value: v, label: labelMap[v] || v });
    onLiteCollectionVisible?.(v === 'Other');
  };

  return (
    <div className="a-container">
      <label htmlFor="SdTransomLite">Transom Lite</label>
      <select id="SdTransomLite" value={selected} onChange={handleChange} disabled={disabled}>
        <option value="MatchDoorLite">{selected === 'MatchDoorLite' ? 'Match Door Lite ✔' : 'Match Door Lite'}</option>
        {showMatchSideLite && (
          <option value="MatchSideLite">{selected === 'MatchSideLite' ? 'Match Side Lite ✔' : 'Match Side Lite'}</option>
        )}
        <option value="Other">{selected === 'Other' ? 'Other ✔' : 'Other'}</option>
      </select>
    </div>
  );
};

export default TransomLite;
